import { defineComponent as _defineComponent } from 'vue'
import { toRef, computed } from 'vue';
import { useSwiper, ManagedSwiper, SwiperNavigationButton } from '@/ui/shared/swiper';
import { FreeMode, Mousewheel } from 'swiper/modules';
import AutoOptimizedImage from '@/ui/shared/image/auto-optimized-image/AutoOptimizedImage.vue';
import AutoOptimizedImageWithZoom from '@/ui/shared/image/auto-optimized-image-with-zoom/AutoOptimizedImageWithZoom.vue';
import { useMainImageLoadManager } from './load-manager-main';
import { SlideRenderState } from '@/ui/shared/swiper/lazyload';


export default /*#__PURE__*/_defineComponent({
  __name: 'PDPSwiperDesktop',
  props: {
    images: { default: () => [] },
    altTextOverride: { default: undefined },
    zoomBackgroundClass: { default: 'u-bg-grey-4' }
  },
  setup(__props: any) {

const props = __props as { images: CarouselImageViewObject[], altTextOverride: string, zoomBackgroundClass: string }



const { swiperManager: swiperManagerThumbs } = useSwiper<CarouselImageViewObject>({
    slides: toRef(props, 'images'),
    swiperOptions: {
        direction: 'vertical',
        loop: false,
        slidesPerView: 5,
        slidesPerGroup: 1,
        spaceBetween: 9,
        freeMode: true,
        modules: [Mousewheel, FreeMode],
        mousewheel: {
            enabled: true,
            sensitivity: 1,
            thresholdDelta: 100,
            thresholdTime: 100
        }
    }
});

const { swiperManager: swiperManagerMain } = useSwiper<CarouselImageViewObject>({
    slides: toRef(props, 'images'),
    swiperOptions: {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        roundLengths: true
    }
});

const { getSlideRenderStatus: getSlideRenderStatusMain } = useMainImageLoadManager(swiperManagerMain);

// Compute the render status of each slide in order to prevent multiple calls to getSlideRenderStatus in the template
const slideStatusesMain = computed(() => {
    return swiperManagerMain.slides.value.map((_, index) => getSlideRenderStatusMain(index));
});


return { __sfc: true,props, swiperManagerThumbs, swiperManagerMain, getSlideRenderStatusMain, slideStatusesMain, ManagedSwiper, SwiperNavigationButton, AutoOptimizedImage, AutoOptimizedImageWithZoom, SlideRenderState }
}

})